module.exports = __webpack_public_path__ + "static/media/romulo.4239722f.jpeg";